var _defs, _g, _polyline, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorOpenBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: white;\n        \n         \n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n         ", "\n        \n      }\n\n      .cls-5 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n        \n      }\n\n      .cls-6 {\n        letter-spacing: -.03em;\n        \n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n        \n      }\n\n      .cls-4 {\n        stroke-linecap: round;\n        \n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.73,62.32V14.94c0-1.06.86-1.92,1.92-1.92h5.51"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 32.73,
    cy: 35.65,
    r: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m53.24,62.32l-24.6,5.91c-.24.06-.47-.13-.47-.37V8.68c0-1.27,1.2-2.19,2.43-1.85l21.24,5.81c.83.23,1.41.99,1.41,1.85v47.83Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 53.66,
    y1: 62.32,
    x2: 60.99,
    y2: 62.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 12.99,
    y1: 62.32,
    x2: 27.61,
    y2: 62.32
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "20.73 62.32 28.16 62.32 28.16 13.02"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(0 -6.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.2,
    y: 0
  }, "oo"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 16.87,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.03,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 22.11,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.1,
    y: 0
  }, "pen"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpenBlack);
export default __webpack_public_path__ + "static/media/__Door - Open Black.725c5e50026c8dcee7640baf9ba8be8c.svg";
export { ForwardRef as ReactComponent };